module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_5.a622d21e.png";